// NATIVE 
import { useCallback, useEffect, useRef, useState } from 'react';

// INSTALLED 
import { useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Button, Card, Divider, Grid, IconButton, Snackbar, Tooltip, Typography } from '@mui/material';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { SnackbarProvider, VariantType, useSnackbar } from 'notistack';


// CUSTOM 
import InputField from '../../formFields/InputField';
import InputNumeric from '../../formFields/InputNumeric';
import CheckboxField from '../../formFields/checkBoxField';
import AutocompleteField from '../../formFields/autocompleteField';
import { IDatosBasicos } from '../../../commons/interfaces';
import DatePickerField from '../../formFields/datePickerField';
import { UploadButtonField } from '../../formFields/uploadButtonField';
import { uploadPdfStore } from '../../../store/uploaders';
import { SnackAlert } from '../../SnackAlert';
import { SnackGroupAlerts } from '../../SnackGroupAlerts';
import { LinearProgressWithLabel } from '../../LinearProgressWithLabel';



// import InputNumeric from '../formFields';

export const Laboral = (props:any) => {


    const dispatch = useDispatch();

    const formikProps:any = useFormikContext();

    // REDUX
    const  {  company }:any  = useSelector( (state:any) => state.company );

    const  { cargos_list }  = useSelector( (state:any) => state.cargos );

    const { payment_method_list, payment_method_list_select }:any = useSelector( (state:any) => state.paymentmethod );
    const { associated_bank_list, associated_bank_select }:any = useSelector( (state:any) => state.associatedbank );

    const { payment_frequency_select }:any = useSelector( (state:any) => state.paymentfrequency );
    
    
    

    const [percentage_upload_bk, setPercentageUploadBk]   = useState(0);

    const [daysRest, setDaysRest] = useState<any>([]);

    

    // ALERTS PARA CONFIGURACION FALTANTE
    const [alert_snack_company, setAlertSnackCompany] = useState(false);
    const [alert_snack_cargos, setAlertSnackCargos] = useState(false);


    const { formField: {
        // DATOS CLIENTE 
        type_contract,
        salary_base,
        transport_subsidy,
        payment_method,
        frecuency_payment,
        associated_bank,
        account_number,
        certificate_bank,
        vacation_acumulate,
        bonification_aditional,
        date_start_contract,
        lunes,
        martes,
        miercoles,
        jueves,
        viernes,
        sabado,
        domingo,
        festivo,
        dayrest,

      }
    } = props;

    

     



    const type_contract_list = [
         { label: 'contrato de aprendizaje sena', value: 'contrato de aprendizaje sena' },
         { label: 'contrato individual de trabajo a termino fijo inferior a un año', value: 'contrato individual de trabajo a termino fijo inferior a un año' },
         { label: 'contrato individual de trabajo a termino indefinido (personal administrativo, direccion – manejo y confianza', value: 'contrato individual de trabajo a termino indefinido (personal administrativo, direccion – manejo y confianza' },
         { label: 'contrato individual de trabajo a termnino indefinido', value: 'contrato individual de trabajo a termnino indefinido' },
         { label: 'termino fijo', value: 'termino fijo' },
    ];


    const uploadCertificateBank = async({ target }:any) => {
   
      formikProps.setFieldValue('certificate_bank', target.files[0]);
      const { ok, data } = await dispatch( uploadPdfStore( 'certificate-bank-empleado', target.files[0], setPercentageUploadBk) );


      
      if (ok) {
        formikProps.setFieldValue('certificate_banck_name_saved_name', data.pdfName);
      }

    }



  // useEffect(() => {
  //   configMission();
  // }, []);
  

  

  // useEffect(() => {
    
  //    ( payment_frequency_select.length <=  ) ? : 
  // }, [payment_frequency_select])
  

  // const configMission = () => {
    
  //   if ( Object.keys(company).length === 0 && company.constructor === Object ) {
  //        setAlertSnackCompany(true);
  //   } // END IF

  //   if ( Object.keys(cargos_list).length === 0  ) {
  //        setAlertSnackCargos(true);
  //   } // END IF

  // }


  const oneDayRest = (day:string) => {

    const found = daysRest.find((element:any) => element == day);

    if ( found ) {

        const elements = daysRest.filter(function(item:any) {
            return item !== day
        });

        setDaysRest(elements);
        formikProps.setFieldValue('dayrest', day);
        
    }else{
        setDaysRest([...daysRest, day]);
        formikProps.setFieldValue('', day);
    }
  }

  

  return (
    <div>
 

        <SnackAlert open={alert_snack_cargos} autohidden={false} onclick={setAlertSnackCargos} text={'Aun no has creado los cargos'} severity={"warning"} />


        

        {/* <SnackbarProvider maxSnack={3}>
          <SnackGroupAlerts message={'aaaaaaa'} variant={'warning'}/>
        </SnackbarProvider> */}

        


        <Grid container spacing={2}>

            <Grid item xs={3}>
                <AutocompleteField 
                   options={type_contract_list}
                   name={type_contract.name}
                   label={type_contract.label}
                   element={type_contract.name}
                />
            </Grid>
            <Grid item xs={3}>
              <InputNumeric 
                name={salary_base.name}
                label={salary_base.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>
            <Grid item xs={3} >
                  <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                  <CheckboxField  name={transport_subsidy.name} label={transport_subsidy.label}/>
                  </div>
            </Grid>
            <Grid item xs={3}>

              {
                                
                ( payment_method_list_select && payment_method_list_select.length > 0 )

                    ?

                    <AutocompleteField
                      options={payment_method_list_select}
                      name={payment_method.name}
                      label={payment_method.label}
                    />

                    :
                    <InputField 
                      disabled
                      error
                      name={'N/A'}
                      label={'Debes crear la frecuancia de pago*'}
                      variant="outlined" 
                      fullWidth
                    />
              }

                
            </Grid>
            


        </Grid>
        {/* END GRID  */}



        
        <Grid container spacing={2} style={{ marginTop: 15 }}>


            <Grid item xs={3}>
                {
                                    
                      ( payment_frequency_select && payment_frequency_select.length > 0 )

                          ?

                          <AutocompleteField
                            options={payment_frequency_select}
                            name={frecuency_payment.name}
                            label={frecuency_payment.label}
                          />

                          :
                          <InputField 
                            disabled
                            error
                            name={'N/A'}
                            label={'Debes crear Los bancos*'}
                            variant="outlined" 
                            fullWidth
                          />
                  }

                    
            </Grid>

            <Grid item xs={3}>

            {
                                
                  ( associated_bank_select && associated_bank_select.length > 0 )
  
                      ?
  
                      <AutocompleteField
                        options={associated_bank_select}
                        name={associated_bank.name}
                        label={associated_bank.label}
                      />
  
                      :
                      <InputField 
                        disabled
                        error
                        name={'N/A'}
                        label={'Debes crear Los bancos*'}
                        variant="outlined" 
                        fullWidth
                      />
              }

                
            </Grid>

            <Grid item xs={3}>
                 <InputField
                    name={account_number.name}
                    label={account_number.label}
                    variant="outlined" 
                    fullWidth
                  />
            </Grid>

            <Grid item xs={3}>
               <UploadButtonField accept={'application/pdf'} 
                                  name={certificate_bank.name} 
                                  label={certificate_bank.label} 
                                  text={'Certificado bancario'} 
                                  onChange={uploadCertificateBank}/>
                  {
                    formikProps.values.certificate_bank 
                        ?
                          <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1, height: '70%',  }}>
                          <LinearProgressWithLabel percentage={percentage_upload_bk} label={formikProps.values.certificate_bank.name} hasIcon={true} /> 
                          </Card>
                        :
                        ''
                  }
            </Grid>


            
             

        </Grid>
        {/* END GRID  */}


        <Grid container spacing={2} style={{ marginTop: 5 }}>

            <Grid item xs={3}>
              <DatePickerField label={date_start_contract.label} 
                                      name={date_start_contract.name}/>

                                      
            </Grid>

            
            <Grid item xs={3}>
              <InputNumeric 
                name={vacation_acumulate.name}
                label={vacation_acumulate.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>

            <Grid item xs={3}>
              <InputNumeric 
                name={bonification_aditional.name}
                label={bonification_aditional.label}
                variant="outlined" 
                fullWidth
              /> 
            </Grid>

        </Grid>
        {/* END GRID  */}


        

        <Divider style={{ marginTop: 25 }}/>
        {
            daysRest.length <= 0 
                && <Typography variant='h6' sx={{ fontWeight: 'bold', marginTop: 10, color: 'red' }}>Debes selecionar al menos un dia de descanso*</Typography>
        }
        <Typography variant='h6' sx={{ fontWeight: 'bold', marginTop: 10 }}>Dias de descanso</Typography>

        <Grid container spacing={2}>

            <Grid item xs={2} >
                  <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                  <CheckboxField onChange={ () => oneDayRest(lunes.name) }  name={lunes.name} label={lunes.label}/>
                  </div>
            </Grid>
            <Grid item xs={2} >
                  <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                  <CheckboxField onChange={ () => oneDayRest(martes.name) }  name={martes.name} label={martes.label}/>
                  </div>
            </Grid>
            <Grid item xs={2} >
                  <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                  <CheckboxField onChange={ () => oneDayRest(miercoles.name) }  name={miercoles.name} label={miercoles.label}/>
                  </div>
            </Grid>
            <Grid item xs={2} >
                  <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                  <CheckboxField onChange={ () => oneDayRest(jueves.name) }  name={jueves.name} label={jueves.label}/>
                  </div>
            </Grid>
            <Grid item xs={2} >
                  <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                  <CheckboxField onChange={ () => oneDayRest(viernes.name) }  name={viernes.name} label={viernes.label}/>
                  </div>
            </Grid>
            <Grid item xs={2} >
                  <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                  <CheckboxField onChange={ () => oneDayRest(sabado.name) }  name={sabado.name} label={sabado.label}/>
                  </div>
            </Grid>
            <Grid item xs={2} >
                  <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                  <CheckboxField onChange={ () => oneDayRest(domingo.name) }  name={domingo.name} label={domingo.label}/>
                  </div>
            </Grid>
            <Grid item xs={2} >
                  <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                  <CheckboxField onChange={ () => oneDayRest(festivo.name) } name={festivo.name} label={festivo.label}/>
                  </div>
            </Grid>
            
        </Grid>

    </div>
  )
}
